import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import './fontawesome.scss';
import './App.css';
import AppRouter from './routes/appRouter';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppRouter/>
  </React.StrictMode>,
);
